import React from 'react';
import { Card } from "react-bootstrap";
import face_image from "../../assets/img/faceAdamJacso.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projJacsoA_robotic.png";

const Adam_Jacso_robotic = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_image}
              /* this will be the text on the banner */
              alt="Artificial Neural Network-based Acceleration of Robotic Motion Planning for Machining Processes"
            />{" "}
            <p className="text7">Ádám Jacsó </p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Department of Manufacturing Science and Engineering, BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Robotic machining enables rapid prototyping and custom manufacturing of complex surfaces.
            However, one of the main challenges in robotic milling is that, unlike traditional machine
            tools, simply calculating the tool trajectory is not enough because multiple robot
            configurations can achieve the same tool motion. Optimising robot motion is complicated due
            to the flexible, multi-axis nature of industrial robots.
            <br/>
            <br/>
            Computer-Aided Manufacturing (CAM) systems offer solutions for robot motion planning;
            however, these software programs typically rely only on geometric rules and manually
            selected preferences rather than performing real motion optimisation. In metal cutting,
            maintaining system stability and ensuring the dimensional and spatial accuracy of the
            workpiece are crucial; therefore, calculating the optimal motion is essential.
            <br/>
            <br/>
            Motion planning necessitates inverse kinematics calculations to determine the position of
            each joint along the tool trajectory. Generally, these calculations are performed using
            numerical methods. The high degrees of freedom of robots often result in an infinite solution
            space, making it necessary to use optimisation methods with specific objective functions to
            identify the most suitable motion for the given circumstances.
            <br/>
            <br/>
            The aim of this project is to calculate optimal motions for specific tool path classes and to
            accelerate the motion planning process using artificial neural networks (ANNs). According to
            the literature, the objective function should minimise fluctuations in acceleration and jerk for
            each joint. By learning the mathematical relationships and characteristics of the optimised
            dataset, the resulting surrogate ANN model should enable real-time motion planning,
            providing a foundation for further research and industrial applications.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Adam_Jacso_robotic;